exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/program-skills-objectives.js-WebpackMultiOutput";